<template>
  <CollapseBlock
    class="mt-2 width-100"
    color="var(--color-main-green)"
    transparent
    :value.sync="show">
    <div
      slot="title"
      class="text-right">
      {{ $t('Common.eventProperties') }}
      <sIcon
        class="ml-2 my-auto"
        :rotate="show ? '-180' : '0'"
        size="10"
        type="arrow"/>
    </div>
    <ul
      class="event-history-agreement"
      :class="{'open': show}">
      <template v-for="(valueItem, valueIndex) in valueFormat">
        <li :key="`eventHistoryAgreementParams_${valueIndex}`">
          <div>
            <b>{{ $t(`Tenders.eventType.${valueItem.editType}`) }}</b>
            <span
              v-if="valueItem.stageTitle"
              class="ml-2 font-size-12">(етап {{ valueItem.stageTitle }})</span>
          </div>
          <ul>
            <li
              v-for="(eventValue, eventValueIndex) in valueItem.diff"
              :key="`eventValueIndex_${eventValueIndex}`">
              {{ eventValue.key }}
              <div
                v-if="eventValue.oldValue && eventValue.oldValue !== eventValue.newValue"
                class="event-history-agreement_old">
                {{ eventValue.oldValue }}
              </div>
              <div
                v-if="eventValue.newValue"
                class="event-history-agreement_new">
                {{ eventValue.newValue }}
              </div>
            </li>
          </ul>
        </li>
      </template>
    </ul>
  </CollapseBlock>
</template>
<script>
import CollapseBlock from 'components/common/CollapseBlock.vue'

/**
 * Информации истории взаимодействий со стадийным согласованием
 */
export default {
  name: 'EventHistoryAgreementParams',
  data() {
    return {
      valueFormat: [],
      show: false,
    }
  },
  methods: {
    compareObjects(obj1, obj2) {
      const diffProperties = {}

      for (const key in obj1) {
        if (obj1?.hasOwnProperty(key)) {
          if (obj2?.hasOwnProperty(key)) {
            if (obj1[key] !== obj2[key]) {
              diffProperties[key] = { oldValue: obj1[key], newValue: obj2[key] }
            }
          } else {
            diffProperties[key] = { oldValue: obj1[key], newValue: undefined }
          }
        }
      }

      for (const key in obj2) {
        if (obj2?.hasOwnProperty(key) && !obj1?.hasOwnProperty(key)) {
          diffProperties[key] = { oldValue: undefined, newValue: obj2[key] }
        }
      }

      return diffProperties
    },
    setText(param) {
      if (!param) {
        return param
      }

      Object.entries(param).forEach(paramProp => {
        const paramItem = paramProp[1]
        const bool = ['isCancelTenderAfterReject', 'moveTenderAfterAgreeSucceeded', 'allowDisagree', 'editTenderWhileAgree', 'allowAddFilesOnAgree']
        if (bool.includes(paramProp[0])) {
          paramItem.newValue = paramItem.newValue ? this.$t('Tenders.Yes') : this.$t('Tenders.No')
          paramItem.oldValue = paramItem.oldValue ? this.$t('Tenders.Yes') : this.$t('Tenders.No')
        } else if (paramProp[0] === 'type') {
          paramItem.newValue = paramItem.newValue ? this.$t(`Tenders.AgreementTypes.${paramItem.newValue}`) : null
          paramItem.oldValue = paramItem.oldValue ? this.$t(`Tenders.AgreementTypes.${paramItem.oldValue}`) : null
        }
        paramItem.key = this.$t(`Tenders.eventProp.${paramProp[0]}`)

      })

      return param
    },
    createValueFormat() {
      if (!this.value || !this.value.length) {
        this.valueFormat = []
      } else {
        const result = this.value.map(i => {
          const from = i.from ? i.from : null
          const to = i.to ? i.to : null
          let stageTitle

          if (i.editType === 'EDITED_AGREEMENT_STAGE') {
            stageTitle = from ? from.title : to.title
          } else {
            stageTitle = from ? from.stageTitle : to.stageTitle
          }

          let compareObjects = this.compareObjects(from, to)
          compareObjects = this.setText(compareObjects)
          return {
            stageTitle: compareObjects.stageTitle ? null : stageTitle,
            editType: i.editType,
            diff: compareObjects
          }
        })
        this.valueFormat = result
      }
    }
  },
  components: {
    CollapseBlock
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler() {
        this.createValueFormat()
      }
    }
  },
  props: {
    value: {
      type: Array
    }
  },
}
</script>
<style scoped lang="scss">
.event-history-agreement {
  list-style-type: decimal;
  background: var(--alert-info-background);
  border-radius: 0 12px 12px;
  transition: all 0.25s;
  padding-left: 32px !important;
  &.open {
    padding: 10px 5px 10px 20px;
  }
  &_old {
    text-decoration: line-through;
    opacity: 0.5;
    font-size: 14px;
  }
  &_new {
    font-size: 14px;
  }
}
</style>
